<template>
    <!-- ViewTicketTable 工单列表 -->
    <el-table 
        :data="list"
        border
        highlight-current-row
        style="width: 100%;"
        @selection-change="selectionChange"
        @sort-change="tableSortChange">
        <div slot="empty">
            <div style="height:50px;">{{tableEmptyPlaceholder || '没有符合条件的数据'}}</div>
            <div>可尝试点击上方的 <b>重置</b> 按钮清空搜索条件, 或点击左侧视图名称, 切换工单视图</div>
            <div>向 <a target="_blank" href="/ticket/h">管理员</a> 寻求帮助</div>
        </div>

        <ViewTicketTableColumn v-for="e in viewColumns"
            :key="e"
            :prop="e"
            @after-close-ticket="afterCloseTicket"/>
    </el-table>
</template>

<script>
const default_view_columns = [
    'Selection', // 复选框
    'TicketMark', // 关注
    'TicketNo_Share', // 编号
    'TicketStatus', // 状态
    'TicketTitle_ShareIfWide_Tag', // 标题
    'TicketPriority', // 优先级
    'TicketType', // 类型
    'CreatorUser', // 创建人
    'DealUser', // 处理人
    'CreatedAt', // 创建时间
    'UpdatedAt', // 更新时间
    'Operation' // 操作
];

export default {
    name : 'ViewTicketTable',

    props : ['list', 'viewId', 'tableEmptyPlaceholder'],

    data() {
        return {
            view : {},
            viewColumns : default_view_columns
        };
    },

    watch : {
        viewId() {
            this.loadView();
        }
    },

    methods : {
        tableSortChange( _val ) {
            // console.log('#59 on tableSortChange', _val);

            this.$emit('sort-change', _val);
        },

        afterCloseTicket() {
            this.$emit('after-close-ticket');
        },

        selectionChange( _val ) {
            this.$emit('selection-change', _val);
        },

        loadView() {
            if ( !!this.viewId ) {
                // console.log('#71 loadView', this.viewId, this);

                this.loadView_0();
                return;
            }

            var _this = this;
            setTimeout(_this.loadView, 100);

            // console.log('#77 loadView', this.viewId, this);
        },

        loadView_0() {
            if ( !this.viewId || 'undefined' == this.viewId ) {
                console.log('#88 loadView_0 return, no viewId', this.viewId);
                return;
            }

            var _this = this;
            sdk.TicketViewApi().findById({
                id : _this.viewId
            }).then(res => {
                if ( !res ) {
                    console.log('#68 loadView_0', res, _this.viewId);
                    return;
                }

                _this.view = res;

                if ( !!res.columns ) {
                    _this.viewColumns = res.columns.split(',');
                } else {
                    _this.viewColumns = default_view_columns;
                }
            });
        }
    },

    mounted() {
        this.loadView();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/ViewTicketTable.vue